import { ScmAnalysesCreate } from "./ScmAnalysesCreate";
import { ScmAnalyses } from "./ScmAnalysesEdit";
import { ScmAnalysesList } from "./ScmAnalysesList";

export default {
  edit: ScmAnalyses,
  list: ScmAnalysesList,
  create: ScmAnalysesCreate,
};
